import React from 'react';
import PropTypes from 'prop-types';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import CheckBoxComponent from '@ecp/common/src/components/checkbox/bo/CheckBoxComponent';
import CheckboxUnstyled from '@ecp/common/src/components/unstyled/checkbox/CheckboxUnstyled';

const LabeledCheckBox = ({ labelText, labelProps, ...props }) => (
  <FlexBox {...props}>
    <CheckboxUnstyled checkboxComponent={CheckBoxComponent} labelProps={labelProps} label={labelText} {...props} />
  </FlexBox>
);

LabeledCheckBox.displayName = 'LabeledCheckBox';
export default LabeledCheckBox;

LabeledCheckBox.propTypes = {
  labelText: PropTypes.string,
  labelProps: PropTypes.object,
  disabled: PropTypes.bool,
};

LabeledCheckBox.defaultProps = {
  labelProps: {
    style: {
      paddingLeft: '6px',
    },
    size: `${boTheme.font.size.small}`,
    color: `${boTheme.color.sub1}`,
    height: '28px',
  },
};
